<div class="pageheader">
    <div class="page-title">
        <h1>Developer</h1>
    </div>
</div>

<app-layout-container [fluid]="true">
    <app-layout-row>
        <app-layout-column [width]="10" offset="1">

            <!-- Search bar row-->
            <app-layout-row margin="4rem">
                <app-layout-column [width]="4" [offset]="3">
                    <dx-autocomplete
                        #searchText
                        [dataSource]="items"
                        valueExpr="name"
                        searchMode="contains"
                        placeholder="Search developer"
                        searchTimeout="500"
                        valueChangeEvent="keyup"
                        (onValueChanged)="onValueChanged($event)"
                        (onSelectionChanged)="onSelectionChanged($event)">
                    </dx-autocomplete>
                </app-layout-column>
            </app-layout-row>

            <!-- Menu items row-->
            <app-layout-row>

                <!-- Favorite column -->
                <app-layout-column [width]="3">
                    <app-menu-page-group caption="Favorites" [showFavoriteIcon]="true">
                        @for (item of favoriteItems; track item) {
                            <app-layout-row>
                                <app-layout-column [width]="12">
                                    <app-menu-page-item
                                        [id]="item.id"
                                        [link]="item.link"
                                        [isFavoriteListItem]="true"
                                        (onFavoriteChanged)="onFavoriteChanged($event)" >
                                            <span>{{item.name}}</span>
                                    </app-menu-page-item>
                                </app-layout-column>
                            </app-layout-row>
                        }
                    </app-menu-page-group>
                </app-layout-column>

                <!-- Items column 1 -->
                <app-layout-column [width]="3">
                    @for (group of groups; track group) {
                        @if (group.column === 1) {
                            <app-menu-page-group [caption]="group.name">
                                @for (item of items; track item){
                                    @if (item.group === group.name) {
                                        <app-layout-row>
                                            <app-layout-column [width]="12">
                                                <app-menu-page-item
                                                    [isFavorite]="isFavorite(item.id)"
                                                    (onFavoriteChanged)="onFavoriteChanged($event)"
                                                    [attr.highlite]="item.highlighted ? true : null"
                                                    [id]="item.id"
                                                    [link]="item.link">
                                                        <span>{{item.name}}</span>
                                                </app-menu-page-item>
                                            </app-layout-column>
                                        </app-layout-row>
                                    }
                                }
                            </app-menu-page-group>
                        }
                    }
                </app-layout-column>

                <!-- Items column 2 -->
                <app-layout-column [width]="3">
                    @for (group of groups; track group) {
                        @if (group.column === 2) {
                            <app-menu-page-group [caption]="group.name">
                                @for (item of items; track item) {
                                    @if (item.group === group.name) {
                                        <app-layout-row>
                                            <app-layout-column [width]="12">
                                                <app-menu-page-item
                                                    [isFavorite]="isFavorite(item.id)"
                                                    (onFavoriteChanged)="onFavoriteChanged($event)"
                                                    [attr.highlite]="item.highlighted ? true : null"
                                                    [id]="item.id"
                                                    [link]="item.link">
                                                        <span>{{item.name}}</span>
                                                </app-menu-page-item>
                                            </app-layout-column>
                                        </app-layout-row>
                                    }
                                }
                            </app-menu-page-group>
                        }
                    }
                </app-layout-column>

                <!-- Items column 3 -->
                <app-layout-column [width]="3">
                    @for (group of groups; track group) {
                        @if (group.column === 3) {
                            <app-menu-page-group [caption]="group.name">

                                @for (item of items; track item) {
                                    @if (item.group === group.name) {
                                        <app-layout-row>
                                            <app-layout-column [width]="12">
                                                <app-menu-page-item
                                                    [isFavorite]="isFavorite(item.id)"
                                                    (onFavoriteChanged)="onFavoriteChanged($event)"
                                                    [attr.highlite]="item.highlighted ? true : null"
                                                    [id]="item.id"
                                                    [link]="item.link">
                                                        <span>{{item.name}}</span>
                                                </app-menu-page-item>
                                            </app-layout-column>
                                        </app-layout-row>
                                    }
                                }
                            </app-menu-page-group>
                        }
                    }
                </app-layout-column>

            </app-layout-row>
        </app-layout-column>
    </app-layout-row>
</app-layout-container>
